import { DO_NOT_EXPORT } from './overrideConstants';
import overrideOptions from './overrideOptions';

const mergeOverridesWithGrades = ({ grades, overrides }) => {
  const gradesWithOverride = grades.map((grade) => {
    const studentOverride = overrides.find(
      ({ studentId }) => studentId === grade.studentId
    );

    if (!studentOverride) {
      return grade;
    }

    // skip `Do not export` grade from csv
    if (studentOverride.code === DO_NOT_EXPORT) {
      return null;
    }

    const overrideValue = overrideOptions[studentOverride.code];

    // invalid value, not available in overrideOptions
    if (!overrideValue) {
      return grade;
    }

    return {
      ...grade,
      grade: overrideValue,
    };
  });

  // filter null value (from `Do not export`)
  return gradesWithOverride.filter((grade) => !!grade);
};

export default mergeOverridesWithGrades;
